var ScoutingPlayersPickerModalController = (function () {
    function ScoutingPlayersPickerModalController() {
    }
    ScoutingPlayersPickerModalController.prototype.cancel = function () {
        this.$uibModal.dismiss();
    };
    return ScoutingPlayersPickerModalController;
}());
angular.module('app.scouting').component('modalPlayersPicker', {
    templateUrl: 'scouting/components/modals/players-picker.html',
    controller: ScoutingPlayersPickerModalController,
    bindings: {
        players: '<',
        report: '<',
        $uibModal: '<modalInstance',
    },
});
;